module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG21013959cf5c79221306a6b3327b8268.21013959.png";